

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getUnreadConnectionNotifications
// GETUNREADCONNECTIONNOTIFICATIONS   

const GETUNREADCONNECTIONNOTIFICATIONS= createAsyncThunk(
  "getUnreadConnectionNotifications/getUnreadConnectionNotifications",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUnreadConnectionNotificationsSlice = createSlice({
  name: "getUnreadConnectionNotificationsSlice",
  initialState: {
    getUnreadConnectionNotifications: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUnreadConnectionNotifications: (state) => {
        state.getUnreadConnectionNotifications.loading = false
        state.getUnreadConnectionNotifications.error = false
        state.getUnreadConnectionNotifications.data = []
        state.getUnreadConnectionNotifications.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUNREADCONNECTIONNOTIFICATIONS.fulfilled, (state, action) => {
      state.getUnreadConnectionNotifications = {
        ...state.getUnreadConnectionNotifications,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADCONNECTIONNOTIFICATIONS.pending, (state, action) => {
      state.getUnreadConnectionNotifications = {
        ...state.getUnreadConnectionNotifications,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADCONNECTIONNOTIFICATIONS.rejected, (state, action) => {
      state.getUnreadConnectionNotifications = {
        ...state.getUnreadConnectionNotifications,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUnreadConnectionNotificationsAction = {
    GETUNREADCONNECTIONNOTIFICATIONS,
};

export { getUnreadConnectionNotificationsAction };
export default getUnreadConnectionNotificationsSlice.reducer;
export const {setInitialStateOfgetUnreadConnectionNotifications} = getUnreadConnectionNotificationsSlice.actions